import { useAccountingStore } from '@/stores/accounting';
import ROUTES from '@/utils/constants/accounting_routes_constants';
import USER_PERMISSIONS from '@/utils/constants/accounting_permissions_constants';

const actions = [
    {
        routeName: ROUTES.AR_DEPOSITS.name,
        items: [
            {
                title: 'add deposit',
                routeName: ROUTES.AR_DEPOSITS_ADD_NEW.name,
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_ADD_DEPOSIT);
                },
            },
        ],
    },
    {
        routeName: ROUTES.AR_RESIDENT_DEPOSITS.name,
        items: [
            {
                title: 'add deposit',
                routeName: ROUTES.AR_RESIDENT_DEPOSITS_ADD_NEW.name,
                allowed: () => {
                    const acctStore = useAccountingStore();
                    return acctStore.hasPermission(USER_PERMISSIONS.ACCT_POST_DEPOSITS);
                },
            },
        ],
    },
];

export default actions;
